var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSunrise(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1926,
    height: 40,
    viewBox: "0 0 1926 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3580_63418)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3580_63418",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1926,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1926,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3580_63418)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1786.71 67.1352C1844.95 123.117 1892.5 190.13 1926 264.805V-130.534C1892.52 -55.8392 1844.95 11.1539 1786.71 67.1352Z",
    fill: "url(#paint0_linear_3580_63418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.333 67.1351C838.251 -1.18181 783.12 -85.926 750.016 -181H362.289C416.718 -87.5507 447.935 21.1024 447.935 137.057C447.935 422.218 259.308 663.293 0 742.481V903.144H841.421C761.994 797.38 714.927 665.941 714.927 523.49C714.927 344.194 789.519 182.327 909.333 67.1551V67.1351Z",
    fill: "url(#paint1_linear_3580_63418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.333 67.1351C1023.13 -42.2401 1177.71 -109.474 1348.02 -109.474C1518.33 -109.474 1672.91 -42.2201 1786.71 67.1351C1844.95 11.1537 1892.5 -55.8594 1926 -130.535V-181H750.017C783.12 -85.926 838.272 -1.16174 909.333 67.1351Z",
    fill: "url(#paint2_linear_3580_63418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.935 137.057C447.935 21.1024 416.718 -87.5306 362.289 -181H0V742.461C259.308 663.293 447.935 422.198 447.935 137.036V137.057Z",
    fill: "url(#paint3_linear_3580_63418)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.333 67.1345C1023.13 176.51 1177.71 243.743 1348.02 243.743C1518.33 243.743 1672.91 176.49 1786.71 67.1345C1672.91 -42.2407 1518.33 -109.474 1348.02 -109.474C1177.71 -109.474 1023.13 -42.2206 909.333 67.1345Z",
    fill: "url(#paint4_linear_3580_63418)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3580_63418",
    x1: 1926,
    y1: 383.585,
    x2: 1926,
    y2: -465.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#99DEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FFCC66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3580_63418",
    x1: 1034.07,
    y1: 988.214,
    x2: -395.413,
    y2: -285.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#99DEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FFCC66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3580_63418",
    x1: 669.695,
    y1: -4.81865,
    x2: 2567.67,
    y2: -4.81866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#99DEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FFCC66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3580_63418",
    x1: -303.318,
    y1: 255.452,
    x2: 549.57,
    y2: 255.452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#99DEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FFCC66"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3580_63418",
    x1: 1086.13,
    y1: 335.535,
    x2: 1502.56,
    y2: -445.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#99DEDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FFCC66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3580_63418"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1926,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunrise);
export default __webpack_public_path__ + "static/media/sunrise.bb7e438567f636bcb57af2c4daa80567.svg";
export { ForwardRef as ReactComponent };